export enum WorksDone {
    None,
    RoofIsolation = "Isolation du toit",
    FloorIsolation= "Isolation du sol",
    WallInternalIsolation = "Isolation des murs",
    WindowIsolation = "Changement des fenêtres",
    CentralHeatingChange = "Changement du système de chauffage principal",
    WoodBurnerChange =  "Installation ou remplacement d'un poêle",
    ChauffeEau = "Installation d'un chauffe-eau",
    PanneauSolaire = "Installation de panneaux solaires",
    InstallOrChangeVMC = "Installation d'un système de ventilation",

}



